import { NgModule } from '@angular/core';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { SharedModule } from '../shared.module';
import {ReactiveFormsModule} from "@angular/forms";
import {AsyncPipe, NgForOf, NgIf} from "@angular/common";

@NgModule({
    declarations: [FileUploadComponent],
    imports: [SharedModule, ReactiveFormsModule, AsyncPipe, NgForOf, NgIf],
    exports: [FileUploadComponent]
})
export class ComponentsModule {}
